import { render, staticRenderFns } from "./2022-3-8.vue?vue&type=template&id=24513cc8&scoped=true&"
import script from "./2022-3-8.vue?vue&type=script&lang=ts&"
export * from "./2022-3-8.vue?vue&type=script&lang=ts&"
import style0 from "./2022-3-8.vue?vue&type=style&index=0&id=24513cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24513cc8",
  null
  
)

export default component.exports